import React from "react";
import { connect } from "react-redux";
import { UserList } from "./components/UserList";

import "./userListContainer.scss";

const UserListWrapper = (props) => {
  return <UserList endpoints={props.endpoints} users={props.users} impersonation={props.impersonation} />;
};

const mapStateToProps = (state) => {
  return {
    endpoints: state.getIn(["config", "endpoints"]),
    users: state.getIn(["impersonation", "users"]),
    impersonation: state.get("impersonation").toJS(),
  };
};

export default connect(mapStateToProps)(UserListWrapper);
